export var HEADING = 'Turn in your best paper';
export var SUBHEADING = 'We check your paper against billions of sources using technology similar to what schools, professors and teachers use';